<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Bem vindo de volta, por favor entre na sua conta.</p>
                </div>

                <vs-tabs>
                  <vs-tab label="Admin">
                    <login-jwt></login-jwt>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {getIp, inRangeIps} from "@/utils";
import LoginJwt from "./LoginJWT.vue";
import tenant from '@/http/requests/tenant';

export default {
  components: {
    LoginJwt,
  },

  methods:{
    async valideTenant() {
      try {
        await this.loginWithToken()
        await tenant.verifyCurrentTenant()
      } catch (e) {
        // Tenant inválido
        if (e.message.includes('Network Error')){
          return await this.$router.push({name: 'page-error-tenant-invalid'})
        }
      }
    },
    async loginWithToken(){
      const ip = await getIp()
      if ( !!this.$route.query.access_token && (
        inRangeIps(ip) ||
        ip === process.env.VUE_APP_LOGIN_ACCESS_TOKEN_OPEN_IP
      )) {
        this.$store.dispatch('auth/integrationLogin', {
          access_token: this.$route.query.access_token
        }).catch((error) => { console.error(error) })
      }
    }
  },
  mounted() {
    this.valideTenant();
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
